import React from "react";

import { Create, SimpleForm } from 'react-admin';

import { AppManagerRoles, UserRole } from '../../../entities/';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';
import { TrucksCreateForm } from './CreateForm';
import { isInArray } from "../../../utils/general";


export const TrucksCreate = ({permissions, ...props}) => {
	const isAdminOrOSFCManager = permissions && isInArray(AppManagerRoles, permissions.role);

	return (
		<Create {...props}>
			<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />} redirect="list">
				<TrucksCreateForm isAdminOrOSFCManager={isAdminOrOSFCManager} />
			</SimpleForm>
		</Create>
	);
};